import styled, { css } from 'styled-components';

export const Panel = styled.div(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s4};
  `,
);

// Video and audio slides share one square stage, so moving between speakers
// never shifts the rest of the screen.
export const Stage = styled.div<{ $fillWidth: boolean }>(
  ({ theme, $fillWidth }) => css`
    position: relative;
    width: 100%;
    aspect-ratio: 1;

    video {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: ${theme.bo.mediumLarge};
    }

    ${
      !$fillWidth &&
      css`
        /* Stacked layouts put the microphone below the speaker, so the stage only
           takes the height left once the prompt and microphone have theirs. The
           floor keeps the speaker recognisable on the shortest screens. */
        @media (max-width: ${theme.sz.xl}) {
          width: clamp(${theme.sz.s20}, calc(100dvh - ${theme.sz.ms}), 100%);
        }

        /* Tall screens get a much larger page inset, which has to come out of the
           same budget. */
        @media (max-width: ${theme.sz.xl}) and (min-height: ${theme.sz.xl}) {
          width: clamp(${theme.sz.s20}, calc(100dvh - ${theme.sz.lg}), 100%);
        }
      `
    }
  `,
);

export const AudioStage = styled.div(
  ({ theme }) => css`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.co.tertiary90};
    border-radius: ${theme.bo.mediumLarge};
  `,
);

// Scales with the stage so the player still fits once the stage shrinks to
// keep the microphone in view on small screens.
export const AudioPlayerWrapper = styled.div(
  ({ theme }) => css`
    width: min(60%, ${theme.sz.s44});
    aspect-ratio: 1;
  `,
);

export const NextSpeakerButton = styled.button(
  ({ theme }) => css`
    position: absolute;
    right: ${theme.sz.s4};
    bottom: ${theme.sz.s4};
    width: ${theme.sz.s12};
    height: ${theme.sz.s12};
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.co.neutral99};
    color: ${theme.co.tertiary0};
    border: none;
    border-radius: ${theme.bo.round};
    font-size: ${theme.sz.s5};
    cursor: pointer;

    svg {
      font-size: 1em;
    }

    &:hover {
      background-color: ${theme.co.tertiary95};
    }
  `,
);

export const Dots = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    gap: ${theme.sz.s2};
  `,
);

export const Dot = styled.button<{ $isActive: boolean }>(
  ({ theme, $isActive }) => css`
    width: ${theme.sz.s2};
    height: ${theme.sz.s2};
    padding: ${theme.sz.s0};
    border: none;
    border-radius: ${theme.bo.round};
    background-color: ${$isActive ? theme.co.tertiary0 : theme.co.tertiary60};
    cursor: pointer;
  `,
);
